import { render, staticRenderFns } from "./DistintaBase.vue?vue&type=template&id=da04a796&"
import script from "./DistintaBase.vue?vue&type=script&lang=js&"
export * from "./DistintaBase.vue?vue&type=script&lang=js&"
import style0 from "./DistintaBase.vue?vue&type=style&index=0&id=da04a796&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports